import axios from "axios";
import router from '../../router';
import slug from 'slug';
import qs from 'qs';

// initial state
const state = () => ({
    'headers': [],
    'items': []
  })

// getters
const getters = {
    getHeaders(state){
        return state.headers;
    },
    getItems(state){
        return state.items;
    }
}

// actions
const actions = {
    
    getSIZReport: {
        //root: true,
        handler (context, query){
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: context.rootGetters.getApiUrl + '/financiar/getSIZReport',
                    params: query,
                    paramsSerializer: function(params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                    headers: { 
                        Authorization: 'Bearer ' + context.rootGetters.getToken,
                        Accept: '*/*'
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    //let token = response.data.token;
                    //context.commit('setToken', token);
                    //localStorage.setItem('access_token', token);
                    //let data = JSON.parse(response.data);
                    console.log(response.data);
                    //let blob = new Blob([response.data], { type: 'application/pdf' });
                    //url = window.URL.createObjectURL(blob);
                    //window.open(url);

                    let shopCode = "ToateAgentiile"
                    if(query.shopId){
                        shopCode = 'Agentia-'+context.rootGetters.getShops.find(el=> el.id == query.shopId ).codSucursala;
                    }
                    let company = slug(context.rootGetters.getManagerCompanies.find(el => el.id == query.companyId ).companyName);
                    //let company = slug('sss');
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'SituatieVenituriZilnice_'+company+'_'+shopCode+'_'+query.date+'.pdf');
                    document.body.appendChild(fileLink);

                    fileLink.click();

                    // let headers = [];
                    // let items = [];
                    // response.data.columnNames.forEach(element => {
                    //     headers.push({'text':element, 'value': slug(element)});
                    // });
                    // context.commit('setHeaders', headers);
                    // response.data.columnValues.forEach(element => {
                    //     let item = {};
                    //     for (var i = 0; i < headers.length; i++) {
                    //         item[headers[i].value] = element[i];
                    //     }
                    //     items.push(item);
                    // });
                    // context.commit('setItems', items);
                    // console.log(headers);
                    // console.log(items);
                    resolve(response);
                })
                .catch(error => {

                    if(error.response.status === 401){
                        //context.dispatch('destroyToken');
                        context.dispatch('destroyToken', null, { root: true })
                            .then(() => {
                                router.push({ name: 'login' });
                            })
                    }
                    reject(error);
                })
            });
        }
    },
    getSILReport: {
        //root: true,
        handler (context, query){
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: context.rootGetters.getApiUrl + '/financiar/getSILReport',
                    params: query,
                    paramsSerializer: function(params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                    headers: { 
                        Authorization: 'Bearer ' + context.rootGetters.getToken,
                        Accept: '*/*'
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    //let token = response.data.token;
                    //context.commit('setToken', token);
                    //localStorage.setItem('access_token', token);
                    //let data = JSON.parse(response.data);
                    console.log(response.data);
                    //let blob = new Blob([response.data], { type: 'application/pdf' });
                    //url = window.URL.createObjectURL(blob);
                    //window.open(url);codSucursala
                    let shopCode = "ToateAgentiile"
                    if(query.shopId){
                        shopCode = 'Agentia-'+context.rootGetters.getShops.find(el=> el.id == query.shopId ).codSucursala;
                    }

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'SituatieVenituriLunare_'+shopCode+'_'+query.date+'.pdf');
                    document.body.appendChild(fileLink);

                    fileLink.click();

                    // let headers = [];
                    // let items = [];
                    // response.data.columnNames.forEach(element => {
                    //     headers.push({'text':element, 'value': slug(element)});
                    // });
                    // context.commit('setHeaders', headers);
                    // response.data.columnValues.forEach(element => {
                    //     let item = {};
                    //     for (var i = 0; i < headers.length; i++) {
                    //         item[headers[i].value] = element[i];
                    //     }
                    //     items.push(item);
                    // });
                    // context.commit('setItems', items);
                    // console.log(headers);
                    // console.log(items);
                    resolve(response);
                })
                .catch(error => {

                    if(error.response.status === 401){
                        //context.dispatch('destroyToken');
                        context.dispatch('destroyToken', null, { root: true })
                            .then(() => {
                                router.push({ name: 'login' });
                            })
                    }
                    reject(error);
                })
            });
        }
    }
}

// mutations
const mutations = {

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}